export default __webpack_public_path__ + "static/media/blue_marker_linear_sci4_spritesheet.f4fcd39b.png";